import { gettext as _ } from "./utils/i18n";
import { readCookie, setCookie } from "./utils/cookies";

function create_element_from_html(htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
}

window.__consent = (function () {
    // You can register window.__consent_callback function for callback after consent

    // constants
    const CONSENT_COOKIE_NAME = "quotepark_consents";
    const CONSENT_COOKIE_SEPARATOR = ",";

    const CONSENT_TYPES = {
        necessary: _("Necessary"),
        statistical: _("Statistical"),
        marketing: _("Marketing"),
    };

    // dialog
    const CONSENT_DIALOG_ID = "consent-dialog";
    const CONSENT_DIALOG_MORE_OPTIONS_ID = "consent-dialog-more-options";
    const CONSENT_DIALOG_MORE_OPTIONS_BUTTON_ID = "consent-dialog-more-options-button";

    // bar
    const CONSENT_BAR_ID = "consent-bar";

    // utils
    const HIDE_CLASS = "d-none";

    // translations
    const msg_header = _("We value your privacy");
    const msg_message = _(
        "We use cookies to provide services, traffic analysis, and ad personalization. Data are shared with our partners. By using the site, you agree."
    );
    const msg_privacy_policy = _("Privacy policy");
    const msg_agree = _("I agree");
    const msg_more = _("More options"); // TODO: rename More options -> Nastavení

    // variables
    let callback_called = false;

    function init() {
        // disable for robots
        var is_robot = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
        if (is_robot) {
            return;
        }

        // load consent based on user location
        // počítám, že v hlavičce stránky je <meta name="ipcountry" content="CZ"> s c kódem země
        // získávám z https://support.cloudflare.com/hc/en-us/articles/200168236-Configuring-Cloudflare-IP-Geolocation
        // vkládám na nginxu
        let meta_ipcountry = document.head.querySelector("[name=ipcountry]") || { content: "" };
        let country_code = meta_ipcountry.content;

        // gdpr by location
        let apply_gdpr = false;
        if (
            [
                "BE",
                "BG",
                "CZ",
                "DK",
                "DE",
                "EE",
                "IE",
                "EL",
                "ES",
                "FR",
                "HR",
                "IT",
                "CY",
                "LV",
                "LT",
                "LU",
                "HU",
                "MT",
                "NL",
                "AT",
                "PL",
                "PT",
                "RO",
                "SI",
                "SK",
                "FI",
                "SE",
                "UK",
                "IS",
                "LI",
                "NO",
                "CH",
            ].indexOf(country_code) != -1
        ) {
            apply_gdpr = true;
        }

        // load consents or show dialog
        const consents = load_consents() || [];
        if (consents.length > 0) {
            call_callback(consents);
        } else if (!apply_gdpr) {
            // opt-out bar
            show_bar();
            window.ga("send", "event", "Consents", "opt-out", { nonInteraction: true });
            call_callback(Object.keys(CONSENT_TYPES)); // do not wait for consent, callback automatically with all consents
        } else {
            // opt-in dialog
            show_dialog();
        }
    }

    function load_consents() {
        const consent_str = readCookie(CONSENT_COOKIE_NAME);

        if (consent_str) {
            let consents = consent_str.split(CONSENT_COOKIE_SEPARATOR);

            // consents must include atleast necessary cookies
            if (consents.indexOf("necessary") != -1) {
                window.ga("send", "event", "Consents", consent_str, { nonInteraction: true });
                return consents;
            }
        }

        return [];
    }

    function save_consents(consents) {
        const consent_str = consents.join(CONSENT_COOKIE_SEPARATOR);
        setCookie(CONSENT_COOKIE_NAME, consent_str, 365);
        window.ga("send", "event", "Consents", consent_str, { nonInteraction: true });
    }

    function call_callback(consents) {
        if (!callback_called) {
            callback_called = true;

            // call after document ready
            if ("__consent_callback" in window) {
                window.__consent_callback(consents);
            }
        }
    }

    function show_bar() {
        // Opt-out solution for non-EU countries

        // TODO: rename classes

        let bar = create_element_from_html(`
            <div id="${CONSENT_BAR_ID}" class="consent-bar container">
                <!--googleoff: all-->
                <p class="consent-bar-msg">${msg_message}</p>
                <div class="consent-bar-controls">
                    <button class="btn btn-primary consent-bar-agree" onclick="__consent.agree_bar()">
                        ${msg_agree}
                    </button>
                    <button class="btn btn-link consent-bar-more" onclick="__consent.hide_bar(); __consent.show_dialog(true);">
                        ${msg_more}
                    </button>
                </div>
                <!--googleon: all-->
            </div>
        `);

        document.body.appendChild(bar);
    }

    function show_dialog(force_more_options = false) {
        // Opt-in solution for EU countries

        const current_consents = load_consents();

        let dialog = document.getElementById(CONSENT_DIALOG_ID);
        if (!dialog) {
            // build html

            let checkboxes_html = "";
            for (let type in CONSENT_TYPES) {
                let name = CONSENT_TYPES[type];
                let extra_attrs = "";

                if (type == "necessary") {
                    extra_attrs += 'disabled="true"';
                }

                // TODO: Do not preselect Analytics and Marketing options (test difference in ratio of consents)

                // if consents are not set or type is in current consents
                if (current_consents.length == 0 || current_consents.indexOf(type) >= 0) {
                    extra_attrs += 'checked="true"';
                }

                checkboxes_html += `
                    <div class="form-check form-check-inline">
                        <input type="checkbox" class="form-check-input" name="consent_dialog_consents[]" id="consent_dialog_checkbox_${type}" value="${type}" ${extra_attrs} />
                        <label for="consent_dialog_checkbox_${type}" class="form-check-label">${name}</label>
                    </div>
                `;
            }

            dialog = create_element_from_html(`
                <div id="${CONSENT_DIALOG_ID}" class="consent-dialog">
                    <!--googleoff: all-->
                    <div class="consent-dialog-content">
                        <h3 class="mt-0">${msg_header}</h3>
                        <p>
                            ${msg_message}
                            
                            <a href="/privacy-policy/">${msg_privacy_policy}</a>
                        </p>
        
                        <div id="${CONSENT_DIALOG_MORE_OPTIONS_ID}" class="${HIDE_CLASS}">
                            ${checkboxes_html}
                        </div>
        
                        <div class="consent-dialog-controls">
                            <button class="btn btn-primary rounded" onclick="__consent.agree_dialog();">${msg_agree}</button>
                            <button id="${CONSENT_DIALOG_MORE_OPTIONS_BUTTON_ID}" class="btn btn-link" onclick="__consent.show_more_options();">${msg_more}</button>
                        </div>
                    </div>
                    <!--googleon: all-->
                </div>
            `);
            document.body.appendChild(dialog);
        }

        if (force_more_options) {
            show_more_options();
        }

        // force to display dialog
        dialog.classList.remove(HIDE_CLASS);
        document.body.classList.add("consent-dialog-open");
    }

    function hide_dialog() {
        let dialog = document.getElementById(CONSENT_DIALOG_ID);
        dialog.classList.add(HIDE_CLASS);
        document.body.classList.remove("consent-dialog-open");
    }

    function agree_dialog() {
        // load consents from dialog html
        const checkboxes = document.getElementsByName("consent_dialog_consents[]");
        const consents = [];
        for (let i = 0, n = checkboxes.length; i < n; i++) {
            if (checkboxes[i].checked) {
                consents.push(checkboxes[i].value);
            }
        }

        save_consents(consents);
        hide_dialog();
        call_callback(consents);
    }

    function show_more_options(e) {
        // show section with checkboxes
        let button = document.getElementById(CONSENT_DIALOG_MORE_OPTIONS_BUTTON_ID);
        button.classList.add(HIDE_CLASS);

        // hide button show options
        let more_options = document.getElementById(CONSENT_DIALOG_MORE_OPTIONS_ID);
        more_options.classList.remove(HIDE_CLASS);
    }

    function agree_bar() {
        save_consents(Object.keys(CONSENT_TYPES)); // set all consents
        hide_bar();
    }

    function hide_bar() {
        let bar = document.getElementById(CONSENT_BAR_ID);
        bar.classList.add(HIDE_CLASS);
    }

    return {
        init: init,

        // dialog actions
        show_dialog: show_dialog,
        agree_dialog: agree_dialog,
        show_more_options: show_more_options,

        // bar actions
        show_bar: show_bar,
        agree_bar: agree_bar,
        hide_bar: hide_bar,
    };
})();

window.__consent.init();
